import { useMemo } from 'react';
import { DEFAULT_MAP_CENTER, parseCoord } from '@/lib/google-maps';
import { useFestivalWorkspaceStore } from '@/stores/festival-workspace-store';
import { InteractiveMap } from './InteractiveMap';

export function LocationMapField({
  includeLocationNameOnlyPrompt = false,
  location,
  locationName = '',
  onLocationChange,
  onLocationNameChange,
  readOnly = false,
  ...rest
}) {
  const festival = useFestivalWorkspaceStore((s) => s.festival);

  const defaultCenter = useMemo(
    () => ({
      lat: parseCoord(festival?.location?.latitude, DEFAULT_MAP_CENTER.lat),
      lng: parseCoord(festival?.location?.longitude, DEFAULT_MAP_CENTER.lng),
    }),
    [festival?.location?.latitude, festival?.location?.longitude],
  );

  return (
    <div className="mb-3">
      <InteractiveMap
        className="location-map-field"
        location={location}
        locationName={locationName}
        onLocationChange={onLocationChange}
        onLocationNameChange={onLocationNameChange}
        readOnly={readOnly}
        showSearch
        geocodeOnPlace
        defaultCenter={defaultCenter}
        {...rest}
      />
    </div>
  );
}
